import { useCareplanContext } from "@/domains/careplan/contexts/use-careplan-context";
import { useAddCareplanCartLine } from "@/domains/careplan/mutations/use-add-careplan-cart-line";
import { useCartSellingPlans } from "@/domains/careplan/queries/use-cart-selling-plans";

/**
 * Puts a removed product back in the order at quantity 1 on the monthly selling plan. Shopify
 * drops a line at quantity 0, so restoring is an add by merchandise id, not an update.
 */
export const useRestoreCareplanCartLine = () => {
  const { cartVariantIds } = useCareplanContext();
  const { data: availableSellingPlans } = useCartSellingPlans(cartVariantIds);
  const { isPending, mutate } = useAddCareplanCartLine();

  const restore = (cartId: string, line: { merchandiseId: string }) => {
    mutate({
      cartId,
      lines: [
        {
          merchandiseId: line.merchandiseId,
          quantity: 1,
          sellingPlanId: availableSellingPlans?.monthly?.id,
        },
      ],
    });
  };

  return { isPending, restore };
};
